import React, { useEffect, useState, forwardRef } from 'react'
import { useLocation } from 'react-router-dom'
import LinkHandler from 'components/atoms/LinkHandler'
import get from 'lodash.get'

import { isHexLight, userCheckMobileScreen } from 'helpers/tools'
import Typography from 'components/atoms/Typography'

// Style
import './NavBarLandingPage.scss'

function NavBarLandingPage(props, ref) {
  const { bgColor, logo, menu } = props
  const isMobile = userCheckMobileScreen()
  const [dropdown, setDropdown] = useState(false)
  const location = useLocation()

  useEffect(() => {
    const body = document.querySelector('body')
    dropdown ? (body.style.overflowY = 'hidden') : (body.style.overflowY = 'auto')
  }, [dropdown])

  useEffect(() => {
    setDropdown(false)
  }, [location.pathname])

  return (
    <section
      className={`navbar navbar-landing-page ${bgColor && !isHexLight(bgColor) ? 'white' : 'black'}`}
      style={{ backgroundColor: bgColor }}
      ref={ref}
    >
      <nav aria-label="Menu de Navegação" className="container">
        <ul className="navbar-items justify-content-between">
          <li>
            <LinkHandler to="/" className="pr-2">
              <img src={logo} alt="Unimed curitiba" className="navbar-img" />
            </LinkHandler>
          </li>
          {isMobile ? (
            <li>
              <button className="navbar-menu" onClick={() => setDropdown(!dropdown)}>
                <i className="icone-menu" role="presentation" />
                <span className="sr-only">Menu</span>
              </button>

              <nav
                aria-label="Menu de navegação mobile"
                className={`navbar-menu-mobile ${dropdown ? 'active' : ''}`}
                style={{ backgroundColor: bgColor }}
              >
                <section className="navbar-menu-header">
                  <Typography variant="h6" color={bgColor && !isHexLight(bgColor) ? 'white' : 'black'}>
                    Menu
                  </Typography>
                  <button onClick={() => setDropdown(!dropdown)}>
                    <i className="icone-close-book" role="presentation" />
                    <span className="sr-only">Fechar</span>
                  </button>
                </section>

                <nav aria-label="Lista menu de navegação">
                  <ul>
                    {Array.isArray(menu) &&
                      menu.map((item, index) => (
                        <li key={`${get(item, 'title')}-${index}`}>
                          <LinkHandler className="navbar-menu-link" to={get(item, 'url.path')}>
                            {get(item, 'title')}
                          </LinkHandler>
                        </li>
                      ))}
                  </ul>
                </nav>
              </nav>
            </li>
          ) : (
            Array.isArray(menu) &&
            menu.map((item, index) => (
              <li key={`${get(item, 'title')}-${index}`}>
                <LinkHandler className="navbar-menu-link" to={get(item, 'url.path')}>
                  {get(item, 'title')}
                </LinkHandler>
              </li>
            ))
          )}
        </ul>
      </nav>
    </section>
  )
}

export default forwardRef(NavBarLandingPage)
